import Scriba from 'react-scriba';

export class DataDocumentReservation {

    static _chargementDocumentReservation(idReservation, idOperation) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation
        };

        var url = "api/Get/GetDocumentReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDocument_Reservations = (filtres, sortedColumn, isSortedDescending, top) => {
        const objet = { filtres, sortedColumn, isSortedDescending, top };
        const url = "api/Liste/ListeDesDocument_Reservations";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDocument_ReservationsLesPlusRecents = (filtres) => {
        const objet = { filtres };
        const url = "api/Liste/ListeDesDocument_ReservationsLesPlusRecents";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementDocumentReservation(idReservation, idOperation, documents) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "documents": documents
        };

        var url = "api/MAJDonnees/EnregistrementDocumentsDossierClientReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDocumentDossierClientReservation(idOperation, idReservation) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation
        };

        var url = "api/Get/GetDocumentsDossierClientReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementRangDocumentDossierClientReservation(idOperation, idReservation, listDocuments) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation,
            "listDocuments": listDocuments
        };

        let url = "api/MAJDonnees/EnregistrementRangDocumentDossierClientReservation";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionDocumentDossierClientReservation(idOperation, idReservation, idTemplate, idInstance, rowGUID) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation,
            "idTemplate": idTemplate,
            "idInstance": idInstance,
            "rowGUID": rowGUID
        };

        let url = "api/MAJDonnees/SuppressionDocumentDossierClientReservation";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onGenererDocumentDossierClientReservation(idOperation, idReservation, listRowGUID) {
        let objet = {
            "idOperation": idOperation,
            "idReservation": idReservation,
            "listRowGUID": listRowGUID
        };

        var url = "api/SignatureElectronique/GenereDocumentDossierClientReservation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSignatureEDOC(idReservation, idOperation, rowGUID) {
        let objet = {
            "idReservation": idReservation,
            "idOperation": idOperation,
            "rowGUID": rowGUID
        };

        var url = "api/SignatureElectronique/SW_EDOCGetContactsSign";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}